(() => {
  document.documentElement.dataset.fansUpcartThemeBridge = 'native-20260810';

  const styleId = 'fans12th-cart-progress-layout-v1';
  const progressCss = `
    .upcart-public-rewards__message,
    .upcart-internal-rewards__message,
    .upcart-public-rewards__message p,
    .upcart-internal-rewards__message p {
      font-size: 13.5px !important;
      font-weight: 650 !important;
      line-height: 18px !important;
    }

    .upcart-public-rewards__message,
    .upcart-internal-rewards__message {
      min-height: 18px !important;
      height: 18px !important;
      margin-bottom: 17px !important;
      display: flex !important;
      align-items: center !important;
      white-space: nowrap !important;
    }

    .upcart-public-rewards__message p,
    .upcart-internal-rewards__message p {
      margin: 0 !important;
    }

    .upcart-public-component-segmented-progress-bar__segments-container,
    .upcart-internal-component-segmented-progress-bar__segments-container {
      display: flex !important;
      gap: 6px !important;
    }

    .upcart-public-component-segmented-progress-bar__segment,
    .upcart-internal-component-segmented-progress-bar__segment {
      flex: 1 1 0 !important;
      min-width: 0 !important;
    }

    .upcart-public-component-segmented-progress-bar__milestone,
    .upcart-internal-component-segmented-progress-bar__milestone {
      left: 50% !important;
      right: auto !important;
      transform: translateX(-50%) !important;
    }

    .upcart-public-component-segmented-progress-bar__milestone-label,
    .upcart-internal-component-segmented-progress-bar__milestone-label,
    .upcart-public-component-segmented-progress-bar__segment:last-child
      .upcart-public-component-segmented-progress-bar__milestone-label,
    .upcart-internal-component-segmented-progress-bar__segment:last-child
      .upcart-internal-component-segmented-progress-bar__milestone-label {
      left: 50% !important;
      right: auto !important;
      width: 84px !important;
      max-width: 84px !important;
      transform: translateX(-50%) !important;
      text-align: center !important;
    }
  `;

  function mountProgressLayout() {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = progressCss;
    root.appendChild(style);
  }

  mountProgressLayout();

  const observer = new MutationObserver(mountProgressLayout);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
